import * as yup from 'yup'

const academyBranchCitySchema = yup
  .string()
  .nullable()
  .when('role', {
    is: 'teacher_admin',
    then: (schema) =>
      schema
        .required('El profesor admin debe tener ciudad Barranquilla o Sincelejo.')
        .test(
          'academy-branch-city',
          'La ciudad del profesor admin debe ser Barranquilla o Sincelejo.',
          (value) => {
            if (!value) return false;
            const normalized = value.trim().toLowerCase();
            return (
              normalized === 'barranquilla' ||
              normalized.startsWith('barranquilla') ||
              normalized === 'sincelejo' ||
              normalized.startsWith('sincelejo')
            );
          }
        ),
    otherwise: (schema) => schema.notRequired(),
  });

export const validateUpdateUsers = yup.object().shape({
    first_name: yup
    .string()
    .min(2, 'El NOMBRE debe tener al menos 2 caracteres')
    .nullable()
    .required("campo requerido"),
    last_name: yup
    .string()
    .min(2, 'El APELLIDO debe tener al menos 2 caracteres')
    .nullable()
    .required("campo requerido"),
    dni: yup
    .string()
    .min(4, 'La cédula debe tener más de 3 caracteres numéricos')
    .nullable()
    .required("campo requerido"),
    phone: yup
    .string()
    .min(3, 'El TELÉFONO debe tener más de 4 caracteres numéricos')
    .nullable()
    .required("campo requerido"),
    email: yup
    .string()
    .email('Introduzca un correo electrónico válido.')
    .nullable()
    .required("campo requerido"),
    password: yup
    .string()
    .min(6, 'Debe introducir una contraseña de al menos 6 caracteres.'),
    role: yup
    .string()
    .oneOf(['user', 'admin', 'seller', 'domiciliary', 'integration', 'teacher', 'teacher_admin'], 'Debes elegir entre estas opciones'),
    status: yup
    .string()
    .oneOf(['active', 'inactive', 'pending security verification', 'pending user data', 'pending validation'], 'Debes elegir entre estas opciones'),
    unlocked_reason: yup.string().nullable(),
    city: academyBranchCitySchema,
})

